import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from 'react-query'
import App from './App.tsx'
import './index.css'
import './i18n'
import { fehlerMelden } from './utils/fehlerMelden'

// Gemeinsamer Cache fuer aggregierte Dashboard- und weitere serverseitige Abfragen.
// Ohne Provider wirft bereits der erste useQuery-Aufruf beim Rendern und die globale
// ErrorBoundary ersetzt die komplette Agentenkonsole.
const queryClient = new QueryClient()

// Handle dynamic import/preload failures gracefully (typically after a redeployment)
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  window.location.reload();
});

// Die beiden Handler filterten bisher NUR auf den Chunk-Fall nach einem Deploy.
// Jeder andere Skriptfehler und jede unbehandelte Zusage verschwanden damit spurlos —
// die ErrorBoundary faengt nur Renderfehler, nicht das, was daneben passiert.
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('Failed to fetch dynamically imported module')) {
    event.preventDefault();
    window.location.reload();
    return;
  }
  fehlerMelden(event.message || 'Unbehandelter Skriptfehler', {
    stack: event.error?.stack,
    url: `${event.filename || location.pathname}:${event.lineno ?? 0}`,
  });
}, true);

window.addEventListener('unhandledrejection', (event) => {
  const grund: any = event.reason;
  if (grund?.message && String(grund.message).includes('Failed to fetch dynamically imported module')) {
    event.preventDefault();
    window.location.reload();
    return;
  }
  // Abgebrochene Netzanfragen sind normal (Seitenwechsel, Abbruch durch den Nutzer)
  // und wuerden das Protokoll fluten, ohne etwas auszusagen.
  const meldung = String(grund?.message || grund || 'Unbehandelte abgelehnte Zusage');
  if (/canceled|aborted|Network Error/i.test(meldung)) return;
  fehlerMelden(meldung, { stack: grund?.stack });
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
)
